import {styled} from "styled-components";
import {styles} from "components/molecules/Input/Input.styles";
import PhoneInput from "react-phone-number-input";

export const PhoneWrapper = styled.div`
    .PhoneInputCountrySelect {
        background: ${({$bgWhite}) => ($bgWhite ? "var(--white)" : "var(--gray-100)")};
        padding: 20px;
        flex-shrink: 0;
        border: 0px;
        outline: none;
        display: block;
        font-family: inherit;
        border-radius: 50px;
        @media screen and (max-width: 576px) {
            padding: 10px;
        }
    }
    .PhoneInputCountry {
        padding: 10px;
        background: ${({$bgWhite}) => ($bgWhite ? "var(--white)" : "var(--gray-100)")};
        border-radius: 50px;
        width: ${({$noFlagWidth}) => ($noFlagWidth ? $noFlagWidth : "72px")};
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        border: 1px solid var(--gray-tune, #dfdfdf);
        @media screen and (max-width: 576px) {
            width: 70px;
            border-radius: 20px;
        }
        .PhoneInputCountryIcon {
            background: transparent;
            box-shadow: none;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
                border-radius: 20px;
                width: 20px;
                height: 20px;
                max-width: 100%;
                object-fit: cover;
            }
        }
    }
    .PhoneInput {
        input {
            ${styles}
        }
    }
`;
